export default "<div class=\"overlay\" *ngIf=\"isVisible\">\n    <div class=\"lds-custom\"><div></div><div></div><div></div></div>\n</div>\n"